<!-- checkbox column -->
@if (checkboxColumnFlag ?? checkableRowFlag) {
  <td (click)="checkableRowFlag ? toggleSelection() : null" class="checkbox-column">
    <mat-checkbox
      #_checkbox
      (change)="$event ? toggleSelection() : null"
      (click)="$event.stopPropagation()"
      (focusin)="focusinCheckboxHandler()"
      [checked]="checkedRow"
      [disabled]="!checkableRowFlag"
      class="mat-checkbox-no-text fxl-row fxla-center-center"
      color="primary"
    >
    </mat-checkbox>
  </td>
}
@if (cardOne) {
  <td
    #cardone
    (click)="click()"
    (touchend)="touchEnd()"
    [ngClass]="{ 'click-area': clickableRow, 'hover-action-buttons': hoverActionButtons }"
    class="column-one"
  >
    <div class="fxl-row fxla-start-start">
      @if (cardOneEditLabel) {
        <div class="display-special-action-buttons">
          <button (click)="editCardOne()" [attr.aria-label]="cardOneEditLabel" [matTooltip]="cardOneEditLabel" mat-icon-button>
            <mat-icon svgIcon="svg_special_edit"></mat-icon>
          </button>
        </div>
      }
      <div class="card-one-content">
        @if (cardOneSecondHatLabel) {
          <app-hat-card
            [hatDisabledFlag]="cardOneSecondHatDisabledFlag"
            [hatHighlightEnabledFlag]="cardOneSecondHatHighlightEnabledFlag"
            [hatLabel]="cardOneSecondHatLabel"
            [hatStyle]="cardOneSecondHatStyle"
            [hatWidth]="cardOneSecondHatWidth"
          ></app-hat-card>
        }
        @if (cardOneHatLabel) {
          <app-hat-card
            [hatDisabledFlag]="cardOneHatDisabledFlag"
            [hatHighlightEnabledFlag]="cardOneHatHighlightEnabledFlag"
            [hatLabel]="cardOneHatLabel"
            [hatStyle]="cardOneHatStyle"
            [hatWidth]="cardOneHatWidth"
          ></app-hat-card>
        }
        <ng-content select="[data-card-one]"></ng-content>
      </div>
    </div>
  </td>
}
<!-- Column two -->
@if (cardTwo) {
  <td
    (click)="click()"
    (touchend)="touchEnd()"
    [ngClass]="{
      'click-area': clickableRow,
      'hover-action-buttons': hoverActionButtons,
      'visible-xs': columnTwoXsVisibleFlag,
      'visible-gt-xs': columnTwoGtXsVisibleFlag,
    }"
    class="column-two"
  >
    <app-hat-card [hatGap]="cardOneSecondHatLabel"></app-hat-card>
    <app-hat-card [hatGap]="cardOneHatLabel"></app-hat-card>
    <div class="fxl-row fxla-start-start">
      @if (cardTwoEditLabel) {
        <div class="display-special-action-buttons">
          <button (click)="editCardTwo()" [attr.aria-label]="cardTwoEditLabel" [matTooltip]="cardTwoEditLabel" mat-icon-button>
            <mat-icon svgIcon="svg_special_edit"></mat-icon>
          </button>
        </div>
      }
      <ng-content select="[data-card-two]"></ng-content>
    </div>
  </td>
}
<!-- Column three -->
@if (cardThree) {
  <td
    (click)="click()"
    (touchend)="touchEnd()"
    [ngClass]="{
      'click-area': clickableRow,
      'hover-action-buttons': hoverActionButtons,
      'visible-xs': columnThreeXsVisibleFlag,
      'visible-gt-xs': columnThreeGtXsVisibleFlag,
    }"
    class="column-three"
  >
    <app-hat-card [hatGap]="cardOneSecondHatLabel"></app-hat-card>
    <app-hat-card [hatGap]="cardOneHatLabel"></app-hat-card>
    <div class="fxl-row fxla-start-start">
      @if (cardThreeEditLabel) {
        <div class="display-special-action-buttons">
          <button (click)="editCardThree()" [attr.aria-label]="cardThreeEditLabel" [matTooltip]="cardThreeEditLabel" mat-icon-button>
            <mat-icon svgIcon="svg_special_edit"></mat-icon>
          </button>
        </div>
      }
      <ng-content select="[data-card-three]"></ng-content>
    </div>
  </td>
}
<!-- Column four -->
@if (cardFour) {
  <td
    (click)="click()"
    (touchend)="touchEnd()"
    [ngClass]="{
      'click-area': clickableRow,
      'hover-action-buttons': hoverActionButtons,
      'visible-xs': columnFourXsVisibleFlag,
      'visible-gt-xs': columnFourGtXsVisibleFlag,
    }"
    class="column-four"
  >
    <app-hat-card [hatGap]="cardOneSecondHatLabel"></app-hat-card>
    <app-hat-card [hatGap]="cardOneHatLabel"></app-hat-card>
    <div class="fxl-row fxla-start-start">
      @if (cardFourEditLabel) {
        <div class="display-special-action-buttons">
          <button (click)="editCardFour()" [attr.aria-label]="cardFourEditLabel" [matTooltip]="cardFourEditLabel" mat-icon-button>
            <mat-icon svgIcon="svg_special_edit"></mat-icon>
          </button>
        </div>
      }
      <ng-content select="[data-card-four]"></ng-content>
    </div>
  </td>
}
<!-- Column five -->
@if (cardFive) {
  <td
    (click)="click()"
    (touchend)="touchEnd()"
    [ngClass]="{ 'click-area': clickableRow, 'hover-action-buttons': hoverActionButtons, 'visible-gt-xs': columnFiveGtXsVisibleFlag }"
    class="column-five"
  >
    <app-hat-card [hatGap]="cardOneSecondHatLabel"></app-hat-card>
    <app-hat-card [hatGap]="cardOneHatLabel"></app-hat-card>
    <div class="fxl-row fxla-start-start">
      @if (cardFiveEditLabel) {
        <div class="display-special-action-buttons">
          <button (click)="editCardFive()" [attr.aria-label]="cardFiveEditLabel" [matTooltip]="cardFiveEditLabel" mat-icon-button>
            <mat-icon svgIcon="svg_special_edit"></mat-icon>
          </button>
        </div>
      }
      <ng-content select="[data-card-five]"></ng-content>
    </div>
  </td>
}
<!-- Column six -->
@if (cardSix) {
  <td
    (click)="click()"
    (touchend)="touchEnd()"
    [ngClass]="{ 'click-area': clickableRow, 'hover-action-buttons': hoverActionButtons }"
    class="column-six"
  >
    <app-hat-card [hatGap]="cardOneSecondHatLabel"></app-hat-card>
    <app-hat-card [hatGap]="cardOneHatLabel"></app-hat-card>
    <div class="fxl-row fxla-start-start fx-hide fx-show-flex_gt-sm">
      @if (cardSixEditLabel) {
        <div class="display-special-action-buttons">
          <button (click)="editCardSix()" [attr.aria-label]="cardSixEditLabel" [matTooltip]="cardSixEditLabel" mat-icon-button>
            <mat-icon svgIcon="svg_special_edit"></mat-icon>
          </button>
        </div>
      }
      <ng-content select="[data-card-six]"></ng-content>
    </div>
  </td>
}
<!-- action column -->
@if (actionColumnFlag) {
  <td
    (click)="clickActionColumn()"
    (touchend)="touchEnd()"
    [ngClass]="{ 'hover-action-buttons': hoverActionButtons }"
    class="action-column"
  >
    <app-hat-card [hatGap]="cardOneSecondHatLabel"></app-hat-card>
    <app-hat-card [hatGap]="cardOneHatLabel"></app-hat-card>
    <div class="floating-action-buttons">
      <div class="display-action-buttons fxl-row fxla-end-center fx-hide fx-show-flex_gt-xs">
        <ng-content select="[action-buttons]"></ng-content>
      </div>
    </div>
  </td>
}
